import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockUi } from 'components/block-ui';
import { AddNewGroupModal } from 'pages/administration.page';
import { ContentBox } from 'components/content-box';
import { LoadingSpinner } from 'components/loading-spinner';
import { ButtonContainer, Button } from 'components/button/index';
import { PageDecorated } from 'pages/page';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSave } from '@fortawesome/pro-regular-svg-icons';

/**
 * @param {boolean} isModalOpen
 * @param {function} onModalClose
 * @param {function} openModal
 * @param {function} saveState
 * @param {array} children
 * @param {boolean} showBlockUi
 * @return {*}
 * @constructor
 */
export const AdminLayoutView = ({ isModalOpen, onModalClose, openModal, saveState, children, showBlockUi }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <BlockUi show={showBlockUi}>
        <LoadingSpinner />
      </BlockUi>
      <AddNewGroupModal show={isModalOpen} onClose={onModalClose} />
      <PageDecorated hasAdminPage="true">
        <ContentBox>
          <ButtonContainer>
            <Button onClick={openModal}>
              <FontAwesomeIcon className="mr-2" icon={faPlus} />
              {t('add_new_policy')}
            </Button>
            <Button onClick={saveState}>
              <FontAwesomeIcon className="mr-2" icon={faSave} />
              {t('save')}
            </Button>
          </ButtonContainer>
          {children}
        </ContentBox>
      </PageDecorated>
    </Fragment>
  );
};
